export default __webpack_public_path__ + "static/media/warning_msg_icon.d00241c2.svg";